<template>
    <div>
        <el-input v-bind="$attrs" v-model="inputValue" size="small" v-if="editable">
            <el-button v-if="editable" slot="append" @click="showModal = true">
                <i class="fa fa-location-arrow"></i>
            </el-button>
        </el-input>
        <span v-else>{{ inputValue }}</span>
        <el-dialog
            v-if="editable"
            :visible.sync="showModal"
            :show-close="false"
            :fullscreen="isMobile"
            :append-to-body="true"
        >
            <addresssearch
                v-model="modelValue"
                :place.sync="modelPlace"
                :address.sync="modelAddress"
                :geocode="geocode"
            />

            <div slot="footer" class="dialog-footer">
                <el-button @click="showModal = false" type="primary" size="small">{{
                    $t('Save')
                }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import platform from 'platform-detect';
import addresssearch from './addresssearch.vue';

export default {
    name: 'addresscoordinatesfield',
    components: { addresssearch },
    props: {
        value: null,
        place: null,
        address: null,
        geocode: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        modelValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        inputValue: {
            get() {
                let { lat, lng } = this.modelValue;

                lat = parseFloat(lat);
                lng = parseFloat(lng);

                if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
                    return `${lat},${lng}`;
                }

                return '';
            },
            set(value) {
                const [lat, lng] = value?.split(',') || [];
                this.modelValue = { lat, lng };
            },
        },
        modelPlace: {
            get() {
                return this.place;
            },
            set(value) {
                this.$emit('update:place', value);
            },
        },
        modelAddress: {
            get() {
                return this.address;
            },
            set(value) {
                this.$emit('update:address', value);
            },
        },
        isMobile() {
            return platform.ios || platform.android;
        },
    },
    methods: {},
};
</script>

<style lang="scss"></style>
